export default __webpack_public_path__ + "28f84be25d14eebc949b48b5d5a1ffb2.ogg";